import { render, staticRenderFns } from "./ECEReceivers.vue?vue&type=template&id=50b72426&scoped=true"
import script from "./ECEReceivers.vue?vue&type=script&lang=js"
export * from "./ECEReceivers.vue?vue&type=script&lang=js"
import style0 from "./ECEReceivers.vue?vue&type=style&index=0&id=50b72426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b72426",
  null
  
)

export default component.exports